import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here
import Config from "../../../../Config.jsx";

import Localization from "../../../../Localization.jsx"

import PinEditor from "../../../../views/stage/PlaybackElement/PinEditor.jsx"
import FilePickerCard from "../../../../views/FilePickerCard.jsx"

import {
  Grid,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Slider,
} from '@material-ui/core';

const playbackKind = 1; // Tag

class TagForm extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    var defaultPayloadData = { kind: 0 };

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      pos_x: 0,
      pos_y: 0,
      countDownLimit: 3600,
      content: "",
      triggerMode: 0,
      surroundSound: 0,
      imageSize: 0,
      payloadData: defaultPayloadData,
      imageFileID: 0,
      soundFileID: 0,

      visibility: 0,
      trashFileIdList: [],
      originalPayloadKind: 0,
    };
    autoBind(this);

    if (this.props.playbackData != null) {
      this.state.pos_x = parseFloat(this.props.playbackData['pos_x']);
      this.state.pos_y = parseFloat(this.props.playbackData['pos_y']);
      this.state.countDownLimit = parseFloat(this.props.playbackData['countdown_limit']);
      this.state.content = this.props.playbackData['content'];
      this.state.triggerMode = this.props.playbackData['trigger_mode'];
      this.state.payloadData = (this.props.playbackData['payload'] != ""? JSON.parse(this.props.playbackData['payload']) : defaultPayloadData);
      this.state.originalPayloadKind = this.state.payloadData['kind'];
      if (this.state.payloadData['kind'] == 1) {
        this.state.soundFileID = this.state.payloadData['file_id'];
      }
      else if (this.state.payloadData['kind'] == 2) {
        this.state.imageFileID = this.state.payloadData['file_id'];
      }
      console.log("payloadData:", this.state.payloadData);
      if('surround_sound' in this.state.payloadData) {
        console.log("surround_sound is defined");
        this.state.surroundSound = this.state.payloadData['surround_sound'];
      }else{
        console.log("surround_sound is undefined");
        this.state.surroundSound = 0;
      }
      console.log("surroundSound:", this.state.surroundSound);

      if('image_size' in this.state.payloadData) {
        console.log("image_size is defined");
        this.state.imageSize = this.state.payloadData['image_size'];
      }else{
        console.log("image_size is undefined");
        this.state.imageSize = 0;
      }
      console.log("imageSize:", this.state.imageSize);
    }
    this.state.visibility = this.props.parent.countdownLimitToVisibility(this.state.countDownLimit);
  }

  onContentChanged(e) {
    this.setState({
      content: e.target.value,
    });
    this.state.content = e.target.value;
  }

  visibilityChanged(e) {
    // let countDownLimit = this.props.parent.visibilityToCountdownLimit(e.target.value);
    this.setState({
      visibility: e.target.value,
      // countDownLimit: countDownLimit,
    });
    this.state.visibility = e.target.value;
    // this.state.countDownLimit = countDownLimit;
  }

  visibilitySliderChanged(e){
    const re = /^[0-9\b]+$/;
    let countDownLimit = e.target.value;
    if (countDownLimit === '' || re.test(countDownLimit)) {
      if(countDownLimit > 3600){
        countDownLimit = 3600;
      }else if (countDownLimit < 1){
        countDownLimit = 1;
      }
      this.setState({
        // visibility: e.target.value,
        countDownLimit: countDownLimit,
      });
      // this.state.visibility = e.target.value;
      this.state.countDownLimit = countDownLimit;
    }
  }

  attachmentTypeChanged(e) {
    let payloadData = this.state.payloadData;
    payloadData['kind'] = e.target.value;

    this.setState({
      payloadData: payloadData,
    });
    this.state.payloadData = payloadData;

    if (parseInt(e.target.value) != this.state.originalPayloadKind) {
      if (payloadData['file_id'] != null) {
        this.setState({ trashFileIdList: [payloadData['file_id']] });
      }
    }
    else {
      this.setState({ trashFileIdList: [] });
    }
  }

  validateInput() {
    let result = true;
    if (this.state.content.trim() == "") {
      this.props.root.addNotification("Tag Description cannot be blank");
      result = false;
    }
    return result;
  }

  updatePlayback(new_id) {
    if (this.state.trashFileIdList.length > 0) {
      for (let i = 0; i < this.state.trashFileIdList.length; i++) {
        if (this.state.trashFileIdList[i] > -1) {
          this.props.root.refs.API.request("mark_file_as_trash", { file_id: this.state.trashFileIdList[i] });
        }
      }
    }

    let requestObj = {
      playback_id: new_id,
      kind: playbackKind,
      trigger_time: (this.props.playbackData? this.props.playbackData['trigger_time'] : this.props.root.refs.stageViewerPage.refs.stageDetailView.refs.stageMediaView.state.playbackTime),
      trigger_mode: this.state.triggerMode,
      should_pause_video: Config.GET_PLAYBACK_CONFIG(playbackKind)['shouldPauseVideo'],
      pos_x: this.state.pos_x,
      pos_y: this.state.pos_y,
      countdown_limit: this.state.countDownLimit,
      content: this.state.content.trim(),
      payload: JSON.stringify(this.state.payloadData),
    };
    this.props.root.refs.API.request("update_playback", requestObj, this.props.parent.updatePlaybackOK, this.props.parent.updatePlaybackFailed);
    console.log("updated payload:", this.state.payloadData);
  }

  onPinPositionUpdate(pos) {
    this.setState({
      pos_x: pos.x,
      pos_y: pos.y,
    });
    this.state.pos_x = pos.x;
    this.state.pos_y = pos.y;
  }

  onAutoplayChanged(e) {
    this.setState({
      triggerMode: e.target.value,
    });
    this.state.triggerMode = e.target.value;
  }

  onImageSizeChanged(e) {
    this.setState({
      imageSize: e.target.value,
    });
    this.state.imageSize = e.target.value;

    let payloadData = this.state.payloadData;
    payloadData['image_size'] = e.target.value;

    this.setState({
      payloadData: payloadData,
    });
    this.state.payloadData = payloadData;
    console.log("payloadData:", this.state.payloadData);
  }

  onSurroundSoundChanged(e) {
    console.log("surroundSound:", e.target.value);
    this.setState({
      surroundSound: e.target.value,
    });
    this.state.surroundSound = e.target.value;

    let payloadData = this.state.payloadData;
    payloadData['surround_sound'] = e.target.value;

    this.setState({
      payloadData: payloadData,
    });
    this.state.payloadData = payloadData;
    console.log("payloadData:", this.state.payloadData);
  }

  onUploadSuccess(res) {
    let payloadData = this.state.payloadData;
    payloadData['file_id'] = res['file_id'];
    this.setState({
      payloadData: payloadData,
    });
    this.state.payloadData = payloadData;

    if (this.state.payloadData['kind'] == 1) {
      this.setState({
        soundFileID: res['file_id'],
      });
      this.state.soundFileID = res['file_id'];
    }
    if (this.state.payloadData['kind'] == 2) {
      this.setState({
        imageFileID: res['file_id'],
      });
      this.state.imageFileID = res['file_id'];
    }
  }

  render() {
    let type = "";
    let file_id = 0;
    if (this.state.payloadData['kind'] == 1) {
      type = "audio";
      file_id = this.state.soundFileID;
    }
    else if (this.state.payloadData['kind'] == 2) {
      type = "image";
      file_id = this.state.imageFileID;
    }
    let allowedExtension = Config.GET_ALLOWED_FILE_EXTENSION(type);

    return (
      <div>
        <Switch condition={this.props.parent.state.activeView}>
          <Case value={0}>
            <PinEditor parent={this} root={this.props.root} ref="pinEditor"
              db_x={this.state.pos_x} db_y={this.state.pos_y}
            />
          </Case>
          <Case value={1}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={2}>
                {Localization.strings.TAG_TEXT}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  value={this.state.content}
                  onChange={this.onContentChanged}
                />
              </Grid>
              <Grid item sm={4}/>
              <Grid item xs={12} sm={2}>
                {Localization.strings.VISIBILITY}
              </Grid>
              <Grid item xs={12} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.visibility}
                    onChange={this.visibilityChanged}
                  >
                    <MenuItem value={0}>{Localization.strings.ALWAYS}</MenuItem>
                    <MenuItem value={1}>{Localization.strings.CUSTOMIZE}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <If condition={this.state.visibility != 0}>
                <Then>
                <Grid item xs={12} sm={2}>
                  {Localization.strings.VISIBILITY_DURATION}
                  </Grid>
                  <Grid item xs={12} sm={10}>
                    {/* <div style={{flex: 1, padding:'36px 0px', margin:'auto'}}> */}
                      <TextField value={this.state.countDownLimit} onChange={this.visibilitySliderChanged} />
                      {/* <Slider
                        value={this.state.countDownLimit}
                        min={1}
                        max={120}
                        step={1}
                        marks
                        valueLabelDisplay="on"
                        onChange={this.visibilitySiderChanged}
                      /> */}
                    {/* </div> */}
                  </Grid>
                </Then>
              </If>
              <Grid item xs={12} sm={2}>
                {Localization.strings.ATTACHMENT}
              </Grid>
              <Grid item xs={12} sm={10}>
                <FormControl>
                  <Select
                    value={(this.state.payloadData['kind']? this.state.payloadData['kind'] : 0)}
                    onChange={this.attachmentTypeChanged}
                  >
                    <MenuItem value={"0"}>{Localization.strings.NONE}</MenuItem>
                    <MenuItem value={"1"}>{Localization.strings.VOICE}</MenuItem>
                    <MenuItem value={"2"}>{Localization.strings.IMAGE}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <If condition={this.state.payloadData['kind'] == 1}>
                <Then>
                  <Grid item xs={12} sm={2}>
                    {Localization.strings.AUTOPLAY_SOUND}
                  </Grid>
                  <Grid item xs={12} sm={10}>
                    <FormControl>
                      <Select
                        value={this.state.triggerMode}
                        onChange={this.onAutoplayChanged}
                      >
                        <MenuItem value={0}>{Localization.strings.NO}</MenuItem>
                        <MenuItem value={1}>{Localization.strings.YES}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    {Localization.strings.SURROUND_SOUND}
                  </Grid>
                  <Grid item xs={12} sm={10}>
                    <FormControl>
                      <Select
                        value={this.state.surroundSound}
                        onChange={this.onSurroundSoundChanged}
                      >
                        <MenuItem value={0}>{Localization.strings.NO}</MenuItem>
                        <MenuItem value={1}>{Localization.strings.YES}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <div style={{margin:'8px 0 0 0'}}>
                      <FilePickerCard parent={this} root={this.props.root} ref="filePickerCard"
                        kind={this.state.payloadData['kind']}
                        localeId={this.props.root.state.targetLocaleData['id']}
                        allowedExtension={allowedExtension}
                        onUploadSuccess={this.onUploadSuccess}
                        file_id={file_id}
                      />
                    </div>
                  </Grid>
                </Then>
              </If>
              <If condition={this.state.payloadData['kind'] == 2}>
                <Then>
                <Grid item xs={12} sm={2}>
                    {Localization.strings.IMAGE_SIZE}
                  </Grid>
                  <Grid item xs={12} sm={10}>
                    <FormControl>
                      <Select
                        value={this.state.imageSize}
                        onChange={this.onImageSizeChanged}
                      >
                        <MenuItem value={0}>{Localization.strings.NORMAL}</MenuItem>
                        <MenuItem value={1}>{Localization.strings.LARGE}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <div style={{margin:'8px 0 0 0'}}>
                      <FilePickerCard parent={this} root={this.props.root} ref="filePickerCard"
                        kind={this.state.payloadData['kind']}
                        localeId={this.props.root.state.targetLocaleData['id']}
                        allowedExtension={allowedExtension}
                        onUploadSuccess={this.onUploadSuccess}
                        file_id={file_id}
                      />
                    </div>
                  </Grid>
                </Then>
              </If>
            </Grid>
          </Case>
        </Switch>
      </div>
    )
  }
}

export default TagForm;
